import { HamburgerIcon } from "@chakra-ui/icons"
import { Flex, Image, IconButton, VStack, HStack, Text, useDisclosure, Drawer, DrawerOverlay, DrawerContent, DrawerBody, Button } from "@chakra-ui/react"
import { Link } from "react-router-dom"
import { colors } from "../../styles";
import MyIcon from "../Icon/MyIcon";
import { useAuthStore } from "../../store";
import { forceLogout } from "../../utils";

export default function Header() {

    const { isGuest } = useAuthStore();
    const { isOpen, onOpen, onClose } = useDisclosure();

    return (

        <Flex
            display={{ 
                base: "flex", 
                lg: "none" 
            }}
            width={"100%"}
            height={"64px"}
            paddingX={5}
            borderBottomWidth={0.5}
            justifyContent={"space-between"}
            alignItems={"center"}
            flexShrink={0}
        >
            <Link to={"/"}>
                <Image src={"/logo_2x.png"} alt="logo" width={12} height={12} objectFit={"contain"} />
            </Link>

            <IconButton
                aria-label={"메뉴 열기"}
                icon={<HamburgerIcon boxSize={6} />}
                variant={"ghost"}
                color={colors.g1}
                onClick={onOpen}
            />

            <Drawer placement={"right"} onClose={onClose} isOpen={isOpen}>
                <DrawerOverlay />
                <DrawerContent>
                <DrawerBody paddingY={8}>
                    <VStack width={"100%"} height={"100%"} justifyContent={"space-between"} alignItems={"stretch"}>
                        <VStack alignItems={"stretch"} gap={6}>
                            <Link to={"/search"} onClick={onClose}>
                                <HStack gap={3}>
                                <MyIcon src={"/svg/capsule-filled.svg"} alt="search" width={28} height={28} />
                                <Text fontSize={16} fontWeight={500} color={colors.g1}>
                                    약품 검색
                                </Text>
                                </HStack>
                            </Link>
                            <Link to={"/chat"} onClick={onClose}>
                                <HStack gap={3}>
                                <MyIcon src={"/svg/message-circle.svg"} alt="chat" width={28} height={28} />
                                <Text fontSize={16} fontWeight={500} color={colors.g1}>
                                    팜챗
                                </Text>
                                </HStack>
                            </Link>
                        </VStack>
                        {!isGuest ? (
                            <Link to={"/me"} onClick={onClose}>
                                <HStack gap={3}>
                                <Image src={"/png/profile.png"} alt="user" width={12} height={12} objectFit={"contain"} />
                                <Text fontSize={16} fontWeight={500} color={colors.g1}>
                                    마이페이지
                                </Text>
                                </HStack>
                            </Link>
                        ) : (
                            <Button variant={"ghost"} color={colors.g1} onClick={forceLogout}>
                                <Text fontSize={16} fontWeight={500} color={colors.g1}>
                                    나가기
                                </Text>
                            </Button>
                        )}
                    </VStack>
                </DrawerBody>
                </DrawerContent>
            </Drawer>
        </Flex>
    );
}